// extracted by mini-css-extract-plugin
var _1 = "TableRowLoader-moduleloader__HS6Sa";
var _2 = "TableRowLoader-moduleloaderActive__HTKCA";
export { _1 as "loader", _2 as "loaderActive" }
